import ReviewPage from '@/pages/reviews/ReviewPage';

export default [
  {
    path: '/reviews',
    name: 'ReviewPage',
    component: ReviewPage
  }
];
